<app-modal-card [visible]="visible" (close)="close.emit()">
	<h1 class="mb-6">{{ title }}</h1>
	<p class="mb-6">{{ text }}</p>
	<div class="flex flex-col items-center sm:items-end sm:flex-row-reverse">
		<app-button class="mb-2" (action)="confirm.emit()">{{ confirmationBtnText }}</app-button>
		<app-button class="mb-2 sm:mr-2" type="secondary" (action)="close.emit()">{{ closeBtnText }}</app-button>
	</div>
</app-modal-card>
